import ContentWrapper from "@/components/wrappers/ContentWrapper";
import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { skipInitialFormValues } from "@/utils/formUtils";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { URLQuery } from "@/utils/queryUtils";
import { Card, Flex, Radio } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { useFilterManualBailAccountMovements } from "../../../../common/api/queries";
import BackNavigationArrow from "../../../../common/components/views/BackNavigationArrow";
import { EntityIdObject } from "../../../../common/types";
import { DEFAULT_FILTER_MANUAL_BAIL_ACCOUNT_MOVEMENTS_QUERY_PARAMS } from "../api";
import { BatchManualBailAccountMovementsTable } from "../components/tables/BatchManualBailAccountMovementsTable";
import { CommissionsBatchStep, ManualBailAccountMovementsReport } from "../enums";
import { ManualBailAccountMovementsFilterPageRequest } from "../types";

export const CommissionsBatchManualBailAccountMovementsContainer = () => {
  const { t } = useTranslation();

  const { id } = useParams<EntityIdObject>() as { id: string };
  const navigate = useNavigate();

  const searchParams = useFilterSearchParams<ManualBailAccountMovementsFilterPageRequest>({
    params: ["report"],
    defaultQueryParamsObject: DEFAULT_FILTER_MANUAL_BAIL_ACCOUNT_MOVEMENTS_QUERY_PARAMS,
  });

  const { data, isFetching, isError } = useFilterManualBailAccountMovements({ id, object: searchParams });

  return (
    <ContentWrapper>
      <DisplayWrapper itemLoaded={!!data} isError={isError}>
        {data ? (
          <>
            <Card
              className="card-box"
              title={
                <BackNavigationArrow>
                  <h2>{t("commissions.batch.titles.manageManualBailAccountMovements")}</h2>
                  <span className="sub-header-info normal-font-size">
                    {t("commissions.batch.titles.batchDetail", { name: data.batch.name })}
                  </span>
                </BackNavigationArrow>
              }
            >
              <Flex justify="center">
                <Radio.Group
                  size="large"
                  buttonStyle="solid"
                  value={searchParams.report ?? ManualBailAccountMovementsReport.ASSOCIATED}
                  onChange={(e) =>
                    navigate(
                      {
                        search: URLQuery.searchParamsToString({
                          searchParams: {
                            ...skipInitialFormValues(
                              { report: e.target.value },
                              DEFAULT_FILTER_MANUAL_BAIL_ACCOUNT_MOVEMENTS_QUERY_PARAMS,
                            ),
                            pageIndex: undefined,
                          },
                          append: true,
                        }),
                      },
                      { replace: true },
                    )
                  }
                >
                  <Radio.Button value={ManualBailAccountMovementsReport.ASSOCIATED}>
                    {t("commissions.batch.enums.manualBailAccountMovementsReport.ASSOCIATED")}
                  </Radio.Button>

                  {data.batch.step !== CommissionsBatchStep.FINISH && (
                    <Radio.Button value={ManualBailAccountMovementsReport.DISASSOCIATED}>
                      {t("commissions.batch.enums.manualBailAccountMovementsReport.DISASSOCIATED")}
                    </Radio.Button>
                  )}
                </Radio.Group>
              </Flex>
            </Card>

            <Card className="card-box">
              <BatchManualBailAccountMovementsTable movementsPage={data} loading={isFetching} />
            </Card>
          </>
        ) : undefined}
      </DisplayWrapper>
    </ContentWrapper>
  );
};
